export const comments_4504526 = {"data":{"data":[],"links":{}}}